export const LOCAL_STORAGE_KEY_ITEM_QUEUEING = 'LOCAL_STORAGE_KEY_ITEM_QUEUEING';
export const BULK_ACTION_ITEM_QUEUED = 'item_queued';
